import { render, staticRenderFns } from "./subsidiaryEntry.vue?vue&type=template&id=36eba123&scoped=true&"
import script from "./subsidiaryEntry.vue?vue&type=script&lang=js&"
export * from "./subsidiaryEntry.vue?vue&type=script&lang=js&"
import style0 from "./subsidiaryEntry.vue?vue&type=style&index=0&id=36eba123&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eba123",
  null
  
)

component.options.__file = "subsidiaryEntry.vue"
export default component.exports